import BlueButton from "../../../../common/BlueButton/BlueButton";
import { useState } from "react";
import InputBar from "../../../../common/InputBar";
import { useTranslation } from "react-i18next";

const Filter = ({
    filterText,
    animationLeft,
    animationRight,
    inputContainerFilterClass,
    updateProfanityFilter,
    deleteProfanityFilter,
    item,
}) => {
    const { t } = useTranslation("profanityPage");

    const [filterInput, setFilterInput] = useState(filterText);
    const [filterStatusMessage, setFilterStatusMessage] = useState("");
    const [filterListItemClass, setfilterListItemClass] = useState(
        "filterListItemVisible",
    );
    const [onUserInputChange, setOnUserInputChange] = useState("");
    const [filterMessageClassName, setFilterMessageClassName] =
        useState("infoTextFilterList");
    const [deleteButtonIsGray, setDeleteButtonIsGray] = useState(false);
    const [updateButtonIsGray, setUpdateButtonIsGray] = useState(true);
    const [isWorking, setIsWorking] = useState(false);

    if (animationLeft && filterListItemClass === "filterListItemVisible")
        setfilterListItemClass("filterListItemVisibleLeftAnimation");
    if (animationRight && filterListItemClass === "filterListItemVisible")
        setfilterListItemClass("filterListItemVisibleRightAnimation");

    //detects changes and highlights the input feld
    const onUserInput = (value) => {
        setOnUserInputChange("update");
        setFilterInput(value);

        if (filterInput && updateButtonIsGray) {
            setUpdateButtonIsGray(false);
        }
    };

    const handelKeyPress = (event) => {
        if (isWorking || !filterInput || event.key !== "Enter") return;

        updateFilter();
    };

    const updateFilter = async () => {
        if (!isWorking && filterInput) {
            //set button off
            setUpdateButtonIsGray(false);
            setIsWorking(true);
            setFilterMessageClassName("infoTextFilterListUpdate");
            setFilterStatusMessage(t("filterUpdateMessage"));

            //call api
            let filterUpdateResponse = await updateProfanityFilter(
                item,
                filterInput,
            );

            if (filterUpdateResponse) {
                //show updated state to user
                setFilterStatusMessage(t("filterUpdatedMessage"));
                setFilterMessageClassName("infoTextFilterListSucceeded");
                setOnUserInputChange(t("filterUpdateSucceded"));
            }

            //reset button & UI
            setTimeout(() => {
                setFilterStatusMessage("");
                setIsWorking(false);
                setUpdateButtonIsGray(true);
                setFilterMessageClassName("infoTextFilterList");
                setOnUserInputChange("");
            }, 1000);
        }
    };

    const deleteFilter = async () => {
        if (!isWorking) {
            //set button off
            setDeleteButtonIsGray(true);
            setIsWorking(true);
            setFilterMessageClassName("infoTextFilterListDelete");
            setFilterStatusMessage(t("filterDeletingMessage"));

            //call api
            let filterDeleteResponse = await deleteProfanityFilter(item);

            // enable button if it fails
            if (!filterDeleteResponse) {
                setIsWorking(false);
                setDeleteButtonIsGray(false);
                setFilterStatusMessage("");
            }
        }
    };

    let displayComponent = (
        <>
            <li className={filterListItemClass}>
                <div className="filterContentContainer">
                    <div className={inputContainerFilterClass}>
                        <InputBar
                            value={filterInput}
                            onInput={(e) => onUserInput(e.target.value)}
                            state={onUserInputChange}
                            onKeyPress={handelKeyPress}
                        />
                    </div>
                    <div className="FilterContentButtonContainer">
                        <div className="FilterContentButtonContainerBlueButtonSmall">
                            <BlueButton
                                text={t("filterUpdateButton")}
                                onClick={updateFilter}
                                isGray={updateButtonIsGray}
                            />
                        </div>
                        <div className="FilterContentButtonContainerDarkerBlueButtonSmall">
                            <BlueButton
                                text={t("filterDeleteButton")}
                                onClick={deleteFilter}
                                isDark={true}
                                isGray={deleteButtonIsGray}
                            />
                        </div>
                    </div>
                    <label className={filterMessageClassName}>
                        {filterStatusMessage}
                    </label>
                </div>
            </li>
        </>
    );

    if (filterStatusMessage)
        displayComponent = (
            <>
                <li className={filterListItemClass}>
                    <div className="filterContentContainer">
                        <label className={filterMessageClassName}>
                            {filterStatusMessage}
                        </label>
                    </div>
                </li>
            </>
        );

    return displayComponent;
};

export default Filter;
